let featureGroup;
const desktop = window.matchMedia('(min-width: 1024px)');

function restoreFeatureGroup() {
  if (!featureGroup) return;
  const { group, rail, release, releaseSection, carouselSection, marker } = featureGroup;
  if (release.isConnected) release.insertBefore(rail, marker.nextSibling);
  marker.remove();
  if (group.isConnected) {
    group.before(releaseSection, carouselSection);
    group.remove();
  }
  featureGroup = undefined;
}

function composeFeatureGroup() {
  restoreFeatureGroup();
  if (!desktop.matches || document.body.dataset.orimodoTemplate !== 'index') return;
  const release = document.querySelector('.orimodo-release');
  const releaseSection = release?.closest('.orimodo-release-section');
  const carouselSection = releaseSection?.nextElementSibling;
  const rail = release?.querySelector('.orimodo-release__rail');
  if (!rail || !carouselSection?.classList.contains('orimodo-carousel-section')) return;
  const marker = document.createComment('orimodo rail original position');
  rail.before(marker);
  const group = document.createElement('div');
  group.className = 'orimodo-feature-group';
  for (const name of release.style) {
    if (name.startsWith('--orimodo-')) group.style.setProperty(name, release.style.getPropertyValue(name));
  }
  releaseSection.before(group);
  group.append(rail, releaseSection, carouselSection);
  featureGroup = { group, rail, release, releaseSection, carouselSection, marker };
}

let contrastController;
function initializeAboutContrast() {
  contrastController?.abort();
  contrastController = new AbortController();
  const signal = contrastController.signal;
  const banner = document.querySelector('.orimodo-about-banner');
  const header = document.querySelector('#header-component');
  if (!header) return;
  if (!banner) {
    delete header.dataset.orimodoContrast;
    return;
  }
  let frame;
  const update = () => {
    frame = undefined;
    const imageBounds = banner.getBoundingClientRect();
    const headerBounds = header.getBoundingClientRect();
    if (imageBounds.top <= headerBounds.bottom && imageBounds.bottom > headerBounds.bottom) {
      header.dataset.orimodoContrast = banner.dataset.navigationContrast || 'light';
    } else {
      delete header.dataset.orimodoContrast;
    }
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, { passive: true, signal });
  window.addEventListener('resize', schedule, { passive: true, signal });
  banner.querySelector('img')?.addEventListener('load', schedule, { signal });
  signal.addEventListener('abort', () => cancelAnimationFrame(frame), { once: true });
  update();
}

let editorFrame;
function refreshSections() {
  cancelAnimationFrame(editorFrame);
  composeFeatureGroup();
  initializeAboutContrast();
}
desktop.addEventListener('change', composeFeatureGroup);
document.addEventListener('shopify:section:unload', (event) => {
  // Rescue the moved rail before Shopify removes either owning section.
  // Unrelated deletions must leave the current composition and contrast intact.
  const removed = event.target;
  if (featureGroup && [featureGroup.releaseSection, featureGroup.carouselSection]
    .some(section => removed === section || removed.contains?.(section))) {
    restoreFeatureGroup();
  }
  editorFrame = requestAnimationFrame(refreshSections);
}, true);
document.addEventListener('shopify:section:load', refreshSections);
document.addEventListener('shopify:section:reorder', refreshSections);
composeFeatureGroup();
initializeAboutContrast();
